import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Alert, Autocomplete } from "@material-ui/lab";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import {
  FETCH_DRIVERS,
  FETCH_DRIVERS_FAILURE,
  FETCH_DRIVERS_SUCCESS,
  GET_CITIES,
  GET_CITIES_FAILURE,
  GET_CITIES_SUCCESS,
  FETCH_LOCAL_DRIVERS,
  FETCH_LOCAL_DRIVERS_SUCCESS,
  FETCH_LOCAL_DRIVERS_FAILURE,
} from "@utils/actionTypes";
import API from "@services/axios";
import { AssignDriverStyle } from "./style";

function AssignDriverPopup(props) {
  const classes = AssignDriverStyle();
  const materialClasses = materialCommonStyles();
  const [scroll] = useState("body");
  const [state, dispatch] = useStore();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (props.open) {
      if (!props.isInterstate) {
        dispatch({ type: FETCH_LOCAL_DRIVERS });
        API.get("drivers/local", {
          params: {
            cityId: props.cityId ? props.cityId : undefined,
          },
        })
          .then((response) => {
            dispatch({
              type: FETCH_LOCAL_DRIVERS_SUCCESS,
              payload: response.data.data,
            });
            setOptions(response.data.data);
          })
          .catch((error) => {
            dispatch({ type: FETCH_LOCAL_DRIVERS_FAILURE, payload: error });
          });
      } else {
        dispatch({ type: FETCH_DRIVERS });
        API.get("drivers", {
          params: {
            order: "ASC",
            orderBy: "driverName",
            filter: { active: true },
            isInterstate: true
          }
        })
          .then((response) => {
            dispatch({
              type: FETCH_DRIVERS_SUCCESS,
              payload: response.data.data,
            });
            setOptions(response.data.data.rows);
          })
          .catch((error) => {
            dispatch({ type: FETCH_DRIVERS_FAILURE, payload: error });
          });
      }

      // Get City From API
      if (state.common.citiesData === null) {
        dispatch({ type: GET_CITIES });
        API.get("master/cities")
          .then((response) => {
            dispatch({
              type: GET_CITIES_SUCCESS,
              payload: response.data.data,
            });
          })
          .catch((error) => {
            dispatch({ type: GET_CITIES_FAILURE, payload: error });
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.cityId]);

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose} />
      </div>
      {props.error && <Alert severity="error">{props.error}</Alert>}
      <DialogTitle id="alert-dialog-title">Assign Driver</DialogTitle>
      <form
        noValidate
        autoComplete="off"
        className={classes.customForm}
        onSubmit={props.formik.handleSubmit}
      >
        <DialogContent>
          <div className="form-row wrap-flex">
            <div className="form-group">
              {!props.isInterstate && (
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  disabled
                >
                  <label className="label-text font-16">City</label>
                  <Select
                    id="city"
                    name="cityId"
                    displayEmpty
                    className={materialClasses.customSelect}
                    MenuProps={{
                      classes: { paper: materialClasses.customSelect },
                    }}
                    value={props.cityId}
                    IconComponent={() => <ExpandMore />}
                  >
                    <MenuItem
                      value={
                        props.cityId === undefined || props.cityId === null
                          ? ""
                          : props.cityId
                      }
                      disabled
                    >
                      Select a city
                    </MenuItem>
                    {state?.common?.citiesData?.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>)
              }

              <FormControl variant="outlined" className={classes.autoComplete}>
                <label className="label-text font-16">Driver</label>
                  <Autocomplete
                    id="assignDriver"
                    popupIcon={<ExpandMore />}
                    className={materialClasses.inputAutoComplete}
                    options={options}
                    getOptionLabel={(option) => option.name}
                    value={
                      options?.find((opt) => opt.id === props.formik.values.assignDriver) || null
                    }
                    onChange={props.formik.handleChange("assignDriver")}
                    disableClearable
                  loading={
                    state?.driver?.gettingLocalDriver ||
                    state?.driver?.gettingDrivers
                  }
                    loadingText="Loading..."
                    noOptionsText="No options"
                    renderOption={(option) => (
                      <ul className={materialClasses.dropdownAutoComplete}>
                        <MenuItem
                          key={option.id}
                          value={option.id}
                        >
                          {option.name}
                        </MenuItem>
                      </ul>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        className="label-text"
                        placeholder={props.isInterstate ? "Search interstate driver" : "Select driver"}
                      />
                    )}
                  />
                <FormHelperText className="error-text">
                  {props.formik.touched.assignDriver &&
                    props.formik.errors.assignDriver}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="bottom-button-block">
          <Button
            className="primary-btn gray-border-btn"
            color="inherit"
            disableElevation
            onClick={props.handleClose}
          >
            CANCEL
          </Button>
          <Button
            className="orange-btn primary-btn center-loading-indicator"
            color="inherit"
            disableElevation
            type="submit"
            disabled={
              state.jobPool?.assigningDriver ||
              state.jobPool?.assigningInterstateJobsNotStartedInPool ||
              state.driver?.gettingLocalDriver ||
              state.driver?.gettingDrivers
            }
          >
            {state.jobPool?.assigningDriver ||
              state.jobPool?.assigningInterstateJobsNotStartedInPool ||
              state.driver?.gettingLocalDriver ||
              state.driver?.gettingDrivers ? (
              <CircularProgress color="inherit" />
            ) : (
              "ASSIGN"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AssignDriverPopup;
